export enum DimeModalEntrypoint {
    LeftNav = 'leftnav',
    SettingsStorage = 'settingsstorage',
    BizBar = 'bizbar',
    UsqPopupV2 = 'usqpopupv2',
    BizBarLearnMore = 'bizbarlearnmore',
    AttachmentEditDesktop = 'attachmenteditdesktop',
    SupportUpsell = 'supportupsell',
    SettingsManageAccount = 'settingsmanageaccount',
    OpenMsg = 'openmsg',
    LgpdAdsIpLocationConsentExit = 'lgpdadsiplocationconsentexit',
    DisplayAdBlockerUpsell = 'displayadblockerupsell',
    NativeAdDefaultUpsell = 'nativeaddefaultupsell',
    NativeAdGoAdFreeMenu = 'nativeadgoadfreemenu',
    NativeAdDeleteUpsell = 'nativeaddelupsell',
    EuAdPromptUpsell = 'euadpromptupsell',
    CopilotCreditError = 'copilotcrediterror',
    AdvertisingPreferences = 'advertisingpreferences',
    PersistentHeader = 'persistentheader',
}
